/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

declare global {
  interface Window {
    Appcues?: {
      identify: (userId: string, properties: Record<string, unknown>) => void;
      track: (event: string, eventAttributes?: Record<string, unknown>) => void;
    };
    AppcuesSettings: {
      enableURLDetection: boolean;
    };
  }
}

/*
  This function initializes Appcues on the frontend.
  Currently, it is only called in non-production environments.
  todo: update to use for production after testing and contract approval.
 */
export const initAppcuesScript = (): void => {
  const appcuesScript = document.createElement('script');
  appcuesScript.type = 'text/javascript';
  appcuesScript.src = `//fast.appcues.com/207834.js`;
  document.body.appendChild(appcuesScript);

  const appcuesSettings = document.createElement('script');
  appcuesSettings.type = 'text/javascript';
  appcuesSettings.text = 'window.AppcuesSettings = { enableURLDetection: true };';
  document.body.appendChild(appcuesSettings);
};

export const initAppcuesForNotaries = (notaryUserId: string, isAdmin: boolean): void => {
  if (!window.Appcues) {
    return;
  }
  window.Appcues.identify(
    notaryUserId, // unique, required
    {
      role: 'Notary', // Current user’s role
      isAdmin, // Whether the user is an admin
    },
  );
};
